import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Container } from '@/components/Container';
import { Flex } from '@/components/Flex';
import { Grid as BaseGrid } from '@/components/Grid';
import { NextImageWithLoader } from '@/components/NextImageWithLoader';
import { Typography } from '@/components/Typography';

const HEIGHT = {
  xs: '275px',
  sm: '600px',
  md: '450px',
};

export const Wrapper = styled(Container)`
  text-align: center;
`;

export const HeaderWrapper = styled(Box)`
  ${({ theme }) => css`
    margin-top: ${theme.spacing(6)};
    ${theme.media.md.up} {
      margin-top: ${theme.spacing(8)};
    }
  `}
`;

export const Description = styled(Typography)`
  * {
    display: inline;
  }

  ${({ theme }) => css`
    margin-top: ${theme.spacing(2)};
    margin-bottom: ${theme.spacing(2)};
    ${theme.media.md.up} {
      margin-top: ${theme.spacing(3)};
      margin-bottom: ${theme.spacing(3)};
      max-width: 600px;
      margin-left: auto;
      margin-right: auto;
    }
  `}
`;

export const Image = styled(NextImageWithLoader)`
  width: 100%;
  height: 100%;
  .next-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
`;

export const Caption = styled.span`
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 6px;
  opacity: 0;
  width: 100%;

  ${({ theme }) => css`
    transition: ${theme.transitions.create('opacity')};
    color: ${theme.colors.white};
    background: rgba(0, 0, 0, 0.4);
    font-size: ${theme.fontSizes.p3};
  `}
`;

export const GridItem = styled.a<{ processing: boolean }>`
  position: relative;

  :hover {
    cursor: ${({ processing }) => (processing ? 'wait' : 'zoom-in')};

    ${Caption} {
      opacity: 1;
    }
  }
`;

export const Grid = styled(BaseGrid)`
  grid-template-columns: repeat(2, 1fr);
  grid-auto-flow: dense;
  grid-template-rows: repeat(3, calc(${HEIGHT.xs} / 3));

  ${({ theme }) => css`
    gap: ${theme.spacing(1)};

    ${theme.media.sm.up} {
      grid-template-rows: repeat(3, calc(${HEIGHT.sm} / 3));
    }

    ${theme.media.md.up} {
      grid-template-rows: repeat(3, calc(${HEIGHT.md} / 3));
    }

    ${theme.media.md.down} {
      width: calc(100% - ${theme.spacing(1)});

      &:nth-child(odd) {
        grid-template-columns: 52% 48%;
      }

      &:nth-child(even) {
        grid-template-columns: 48% 52%;
      }
    }
  `}

  ${GridItem}:nth-child(1) {
    grid-row: 1 / 3;
  }

  ${GridItem}:nth-child(2) {
    grid-row: span 1;
  }

  ${GridItem}:nth-child(3) {
    grid-row: span 2;
  }

  ${GridItem}:nth-child(4) {
    grid-row: span 1;
  }
`;

export const PhotosContainer = styled(Flex)`
  gap: 8px;
  flex-flow: row wrap;
  padding-top: ${({ theme }) => theme.spacing(2)};
`;

export const Column = styled(Box)`
  flex-grow: 1;
  width: 100%;

  ${({ theme }) => css`
    ${theme.media.md.up} {
      flex-basis: 33%;
    }

    ${theme.media.md.down} {
      &:nth-child (odd)${Grid} {
        grid-template-columns: 52% 48%;
      }

      &:nth-child(even) ${Grid} {
        grid-template-columns: 48% 52%;
      }
    }
  `}
`;
